module.exports = __webpack_public_path__ + "img/glaxy.851a28e8.png";